<app-page-title 
    *ngIf="!breadcrumbList"
></app-page-title>

<nav *ngIf="breadcrumbList && breadcrumbList.length > 0">
    <ol class="breadcrumb mb-0">
        <li 
            class="breadcrumb-item d-flex align-items-center" 
            *ngFor="let breadcrumb of breadcrumbList; let last = last"
        >
            <a 
                *ngIf="!last"
                class="text-decoration-none fs-5" 
                [routerLink]="breadcrumb.url"
                [queryParams]="breadcrumb.queryParams" 
                [title]="breadcrumb.label"
            > 
                {{ breadcrumb.label | truncate: 30 }}
            </a>
            <h4 
                class="m-0"
                *ngIf="last"
                [title]="breadcrumb.label"
            >{{ breadcrumb.label | truncate: 40 }}</h4>
        </li>
    </ol>
</nav>